<template>
  <el-table
    ref="tableRef"
    :data="tableData"
    v-loading="listLoading"
    border
    fit
    highlight-current-row
    style="width:100%"
    row-key="id"
    default-expand-all
    @selection-change="handleSelectionChange"
  >
    <el-table-column
      v-if="hadSelect"
      type="selection"
      :selectable="selectable"
      width="50"
    />
    <el-table-column
      :key="'t-column'+index"
      v-for="(item, index) in columnStruct.filter(c => !c.icon)"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
      :sortable="item.sortable"
      :formatter="item.formatter"
      header-align="left"
      :align="item.align"
      show-overflow-tooltip
    />
    <el-table-column
      :key="'t-column-icon'+index"
      v-for="(item, index) in columnStruct.filter(c => c.icon)"
      :prop="item.prop"
      :label="item.label"
      :width="item.width ? item.width : 120"
      :sortable="item.sortable"
      :formatter="item.formatter"
      header-align="left"
      :align="item.align"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <el-tooltip
          v-if="item.showIcon(row)"
          :content="item.formatterIconTooltip ? item.formatterIconTooltip(row[item.iconTooltip]) : row[item.iconTooltip]"
          placement="left-end"
        >
          <i
            v-if="item.icon(row)==='success'"
            style="font-size: 20px; color:#098905; padding-right: 5px;"
            :class="'el-icon-' + item.icon(row)"
          />
          <i
            v-else-if="item.icon(row)==='warning'"
            class="warning-item"
            :class="'el-icon-' + item.icon(row)"
          />
          <i
            v-else
            style="font-size: 20px; color:#ff4949; padding-right: 5px;"
            :class="'el-icon-' + item.icon(row)"
          />
        </el-tooltip>
        <span>{{ item.formatter(row) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="hadOperate"
      :label="t(operateText)"
      :width="operateColumnWidth"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <slot
          :row="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElTable } from 'element-plus'

export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const selectedRows = ref<any[]>([])

    const getSelectionRows = () => {
      return selectedRows.value || []
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        selectedRows.value = []
      }
    }
    const handleSelectionChange = (val: any) => {
      selectedRows.value = val
    }
    return {
      t,
      tableRef,
      handleSelectionChange,
      getSelectionRows,
      clearSelection
    }
  }
})
</script>
<style scoped>
.warning-item {
  font-size: 20px;
  color:var(--warning-color);
  padding-right: 5px;
}
</style>
